/* ALUMA RTL fixes ‚Äî slider paging patch for RTL pages.
   Replaces the Sense RTL app's slider script. With the document in RTL,
   the first slide's offsetLeft is negative, so the stock page math
   (clientWidth - offsetLeft) overcounts; use abs(clientWidth + offsetLeft). */
(function () {
  if (typeof SliderComponent === 'undefined') return;
  try {
    SliderComponent.prototype.initPages = function () {
      if (!this.sliderItems) return;
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(function (el) {
        return el.clientWidth > 0;
      });
      if (this.sliderItemsToShow.length < 2) return;
      this.sliderItemOffset =
        this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.slidesPerPage = Math.floor(
        Math.abs(
          (this.slider.clientWidth + this.sliderItemsToShow[0].offsetLeft) /
            this.sliderItemOffset
        )
      );
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
      this.update();
    };
  } catch (e) {}
})();
/* free-intro funnel: keep the first box at 0 - drop the shipping-protection add-on */
(function () {
var BAD = 52660913176868;
var FREE = 15390331076900;
var p = location.pathname;
if (p.indexOf('/cart') !== 0 && p.indexOf('aluma-free-intro') === -1) return;
var busy = false;
function strip() {
if (busy) return;
busy = true;
fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
var hasFree = c.items.some(function (i) { return i.product_id === FREE; });
var bad = c.items.filter(function (i) { return i.variant_id === BAD; })[0];
if (!hasFree || !bad) return;
return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: bad.key, quantity: 0 }) }).then(function () {
if (p.indexOf('/cart') === 0) { location.reload(); } else { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); }
});
}).catch(function () {}).then(function () { busy = false; });
}
strip();
setInterval(strip, 1500);
})();

/* free-intro: flavour swatches as selectable cards */
(function () {
  if (location.pathname.indexOf('aluma-free-intro') === -1) return;
  var COFFEE = '\u05E7\u05E4\u05D4';
  var CHAI = '\u05E6\u2019\u05D0\u05D9';
  var BEST = '\u05D4\u05DB\u05D9 \u05E0\u05DE\u05DB\u05E8!';
  var FRESH = '\u05D7\u05D3\u05E9!';
  var COFFEE_IMG = '/cdn/shop/files/2.png?crop=top&height=760&width=900';
  function build() {
    var c = document.querySelector('.color-swatches-container');
    if (!c) return;
    c.classList.add('fi-flav');
    Array.prototype.forEach.call(c.querySelectorAll('.color-swatch'), function (sw) {
      var inp = sw.querySelector('input');
      if (!inp) return;
      var v = (inp.value || '').trim();
      if (!sw.querySelector('.fi-sw__name')) {
        var n = document.createElement('span');
        n.className = 'fi-sw__name';
        n.textContent = v;
        sw.appendChild(n);
      }
      if (!sw.querySelector('.fi-sw__badge') && (v === COFFEE || v === CHAI)) {
        var b = document.createElement('span');
        b.className = 'fi-sw__badge' + (v === CHAI ? ' fi-sw__badge--new' : '');
        b.textContent = v === CHAI ? FRESH : BEST;
        sw.appendChild(b);
      }
      if (v === COFFEE) {
        sw.classList.add('fi-contain');
        var im = sw.querySelector('img');
        if (im && im.src.indexOf('crop=top') === -1) {
          im.removeAttribute('srcset');
          im.removeAttribute('sizes');
          im.src = COFFEE_IMG;
        }
      }
      sw.classList.toggle('is-sel', inp.checked);
    });
  }
  var t = null;
  function sched() { if (t) return; t = setTimeout(function () { t = null; build(); }, 80); }
  function watch() { if (document.body) new MutationObserver(sched).observe(document.body, { childList: true, subtree: true }); }
  build();
  document.addEventListener('DOMContentLoaded', function () { build(); watch(); });
  document.addEventListener('change', sched, true);
  document.addEventListener('click', sched, true);
  watch();
})();

/* free-intro: one unit only, straight to checkout, cart drawer never opens */
(function () {
  if (location.pathname.indexOf('aluma-free-intro') === -1) return;
  var PLAN = 692061602084;
  var PRODUCT = 15390331076900;
  var VARIANTS = [];
  var going = false;

  var st = document.createElement('style');
  st.textContent =
    'cart-drawer,#CartDrawer,cart-notification,#cart-notification,' +
    '.cart-drawer,.cart-notification{display:none !important;}';
  (document.head || document.documentElement).appendChild(st);

  function go() {
    if (going) return;
    going = true;
    window.location.href = '/checkout';
  }

  function variantOf(f) {
    var n = f.querySelector('[name="id"]');
    return n ? String(n.value) : '';
  }

  function addOnce(variant) {
    if (going) return;
    going = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var inCart = (c.items || []).some(function (i) {
          return i.product_id === PRODUCT;
        });
        if (inCart) return null;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: Number(variant),
            quantity: 1,
            selling_plan: PLAN
          })
        });
      })
      .catch(function () {})
      .then(function () {
        window.location.href = '/checkout';
      });
  }

  document.addEventListener(
    'submit',
    function (e) {
      var f = e.target;
      if (!f || !f.getAttribute) return;
      var action = f.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;
      var v = variantOf(f);
      if (!VARIANTS.length || VARIANTS.indexOf(v) === -1) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      addOnce(v);
    },
    true
  );

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var btn = t.closest('[type="submit"]');
      if (!btn) return;
      var f = btn.form || btn.closest('form');
      if (!f) return;
      var action = f.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;
      var v = variantOf(f);
      if (!VARIANTS.length || VARIANTS.indexOf(v) === -1) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      addOnce(v);
    },
    true
  );

  fetch('/products/aluma-free-intro.js', {
    headers: { Accept: 'application/json' }
  })
    .then(function (r) { return r.json(); })
    .then(function (p) {
      VARIANTS = (p.variants || []).map(function (v) { return String(v.id); });
    })
    .catch(function () {});
})();


/* ---- shipping insurance = monthly subscription (Itay 2026-10-29) --------
   The insurance variant (52660913176868) reaches /cart/add through TWO
   different paths, and neither of them carries a selling_plan on its own, so
   checkout used to show it as a plain one-time 12 ILS line:

   1. Manual toggle inside the cart drawer -> <cart-drawer-upsell> submits a
      plain product form with name="id".
   2. The toggle is ON by default -> the theme folds the upsell into the MAIN
      "add to cart" request as items[0][id] / items[0][quantity].

   Both paths end up in main.js handleSubmit, which does new FormData(form).
   So the reliable hook is the FormData CONSTRUCTOR: whatever the form looked
   like, we inspect the finished entry list and append the selling_plan.

   Three dead ends, do not retry them:
   - Patching window.fetch. Another script on this storefront captures
     window.fetch while the head is parsed and installs its own wrapper
     later, silently discarding any patch made from a deferred script.
   - Patching FormData.prototype.append. The items[N][*] fields come from
     hidden inputs read by the constructor, so append() never sees them.
   - Stamping items[N][selling_plan] into the DOM. Those hidden inputs are
     created inside handleSubmit, in the same task as the submit, so a
     MutationObserver always runs too late.
   Verified 2026-10-29. */
(function () {
  var V = '52660913176868';
  var PLAN = '692467138852';

  var Native = window.FormData;

  function fix(fd) {
    var idx = null, plain = false;
    fd.forEach(function (v, k) {
      if (String(v).trim() !== V) return;
      var m = String(k).match(/^items\[(\d+)\]\[id\]$/);
      if (m) idx = m[1];
      else if (k === 'id') plain = true;
    });
    if (idx !== null && !fd.has('items[' + idx + '][selling_plan]')) {
      fd.append('items[' + idx + '][selling_plan]', PLAN);
    }
    if (plain && !fd.has('selling_plan')) fd.append('selling_plan', PLAN);
  }

  function Patched(form) {
    var fd = arguments.length ? new Native(form) : new Native();
    try { fix(fd); } catch (e) {}
    return fd;
  }
  Patched.prototype = Native.prototype;
  window.FormData = Patched;

  /* belt and braces for the plain-form path: a real hidden input, so the
     insurance keeps its plan even if something bypasses the constructor. */
  function stamp() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (f) {
      var id = f.querySelector('[name="id"]');
      if (!id || String(id.value).trim() !== V) return;
      if (f.querySelector('[name="selling_plan"]')) return;
      var h = document.createElement('input');
      h.type = 'hidden';
      h.name = 'selling_plan';
      h.value = PLAN;
      f.appendChild(h);
    });
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; stamp(); }, 50);
  }

  stamp();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', stamp);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
